<template>
  <div>
    <Breadtabsheader/>
    <div class="h-content w-content">
      <!--查询表单-->
      <div class="h-piece">
        <div class="h-formBox">
          <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder" ref="form">
            <div class="h-thirdColumn w-newColumn">
              <el-form-item label="经销商编码/名称" prop="agentCode">
                <el-input v-model="q.agentCode" placeholder="请输入经销商编码或名称"></el-input>
              </el-form-item>
              <el-form-item label="渠道" prop="channelCode">
                <brselect category="fl_sales_region_main" :v="q.channelCode" v-model="q.channelCode" :multiple="true"
                          :clearable="true"/>
              </el-form-item>
              <el-form-item label="返利归属产业" prop="belongIndustry">
                <brselect category="fl_belong_industry" :v="q.belongIndustry" v-model="q.belongIndustry" :multiple="true"
                          :clearable="true"/>
              </el-form-item>
              <el-form-item label="签约链群" prop="rebateChainGroup">
                <brselect category="fl_25_chain_group" :v="q.rebateChainGroup" v-model="q.rebateChainGroup" :multiple="true"
                          :clearable="true"/>
              </el-form-item>
            </div>
            <el-collapse-transition>
              <div v-show="isScreen">
                <div class="h-thirdColumn w-newColumn">
                  <el-form-item label="区域" prop="area">
                    <brselect category="YLRegion" :v="q.areaCode" v-model="q.areaCode" :multiple="true"
                              :clearable="true"/>
                  </el-form-item>
                  <el-form-item label="经销商类型" prop="agentType">
                    <brselect category="fl_agent_type" :v="q.agentType" v-model="q.agentType" :clearable="true"/>
                  </el-form-item>
                  <el-form-item label="领域" prop="field">
                    <brselect category="fl_field" :v="q.field" v-model="q.field"
                              :clearable="true"/>
                  </el-form-item>
                </div>
              </div>
            </el-collapse-transition>
            <div class="l-screenBox">
              <div class="l-screen" @click="collapseChange">
                <img :src="isScreen?closeScreen:drawScreen" alt="">
                <div class="l-screenText">{{ isScreen ? "收起" : "展开" }}</div>
              </div>
              <div class="l-retrieval">
                <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                <el-button class="h-btn h-formBtn h-bgwhite" @click="reset">重置</el-button>
              </div>
            </div>
          </el-form>
        </div>
      </div>
      <!--展示表格-->
      <div class="h-table h-mrt30">
        <el-table :model="q"
                  ref="q"
                  :data="tableData"
                  stripe
                  style="width: 100%"
                  :border="true"
                  max-height="530"
        >
          <el-table-column prop="area" label="区域" width="80" fixed/>
          <el-table-column prop="agentType" label="经销商类型" width="100">
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{scope.row.agentType|dictname('fl_agent_type')}}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="agentCode" label="经销商编码" width="110" fixed>
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{ scope.row.agentCode }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="agentName" label="经销商名称" min-width="180" fixed>
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{ scope.row.agentName }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="field" label="领域" width="80" fixed>
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{scope.row.field|dictname('fl_field')}}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="channelCode" label="渠道" width="100">
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{scope.row.channelCode|dictname('fl_sales_region_main')}}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="belongIndustry" label="返利归属产业" width="120">
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{ scope.row.belongIndustry|dictname('fl_belong_industry')}}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="rebateChainGroup" label="签约链群" width="100">
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{ scope.row.rebateChainGroup|dictname('fl_25_chain_group')}}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Q1">
            <el-table-column prop="firstQuarterM" label="目标(万元)" width="100">
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.firstQuarterM || 0).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="firstQuarter" label="销额(万元)" width="100">
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.firstQuarter || 0).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="firstQuarterL" label="履约率" width="80">
              <template slot-scope="scope">
                <div style="text-align: right;">{{ (Number(scope.row.firstQuarterL || 0).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="Q2">
            <el-table-column prop="secondQuarterM" label="目标(万元)" width="100">
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.secondQuarterM || 0).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="secondQuarter" label="销额(万元)" width="100">
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.secondQuarter || 0).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="secondQuarterL" label="履约率" width="80">
              <template slot-scope="scope">
                <div style="text-align: right;">{{ (Number(scope.row.secondQuarterL || 0).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="Q3">
            <el-table-column prop="thirdQuarterM" label="目标(万元)" width="100">
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.thirdQuarterM || 0).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="thirdQuarter" label="销额(万元)" width="100">
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.thirdQuarter || 0).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="thirdQuarterL" label="履约率" width="80">
              <template slot-scope="scope">
                <div style="text-align: right;">{{ (Number(scope.row.thirdQuarterL || 0).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="Q4">
            <el-table-column prop="fourthQuarterM" label="目标(万元)" width="100">
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.fourthQuarterM || 0).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="fourthQuarter" label="销额(万元)" width="100">
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.fourthQuarter || 0).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="fourthQuarterL" label="履约率" width="80">
              <template slot-scope="scope">
                <div style="text-align: right;">{{ (Number(scope.row.fourthQuarterL || 0).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="全年合计">
            <el-table-column prop="yearM" label="目标(万元)" width="100">
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.yearM || 0).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="yearS" label="销额(万元)" width="100">
              <template slot-scope="scope">
                <div style="text-align: right;">{{ Number(scope.row.yearS || 0).toFixed(2) }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="yearL" label="履约率" width="80">
              <template slot-scope="scope">
                <div style="text-align: right;">{{ (Number(scope.row.yearL || 0).toFixed(2)) + '%' }}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column prop="jgcj" label="价格层级" width="120" fixed="right">
            <template slot-scope="scope">
              <div style="text-align: left;">
                {{ scope.row.jgcj || '未签约' }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="lvyueStatus" label="履约状态" width="100" fixed="right">
            <template slot-scope="scope">
              <div style="text-align: left;">
                <span v-if="scope.row.lvyueStatus">{{ scope.row.lvyueStatus }}</span>
                <span v-else style="color: #999;">-</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="h-tableB h-mrt30">
          <div class="h-tableBL">
            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                       @click="exportExcel" v-auth="'khlybbXs_daochu'">批量导出
            </el-button>
          </div>
          <div class="h-pagination2">
            <pagination :page="q" @query="query"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ss from '../../../api/SystemService'
import updownfile from '../../../utils/updownfile'

export default {
  components: {},
  data() {
    return {
      isScreen: false,
      closeScreen: require("@/assets/images/pimg/closeallic.png"),
      drawScreen: require("@/assets/images/pimg/dobleArr.png"),
      q: {
        agentName: '',
        agentCode: '',
        channelCode: null,
        rebateChainGroup: null,
        belongIndustry: null,
        areaCode: null,
        agentType: '',
        field: '',
        pageSize: 10,
        pageNo: 1,
        total: 0
      },
      tableData: [],
    }
  },
  created() {
    this.q.agentCode = this.$route.query.agentCode || ''
    this.handleFilter();
  },
  methods: {
    collapseChange() {
      this.isScreen = !this.isScreen;
    },
    handleFilter() {
      this.query();
    },
    reset() {
      this.q = {
        agentType : '',
        agentName: '',
        agentCode: '',
        channelCode: null,
        rebateChainGroup: null,
        belongIndustry: null,
        areaCode: null,
        field: '',
        pageSize: 10,
        pageNo: 1,
        total: 0
      };
      this.handleFilter();
    },
    query() {
      ss.fanli.getPriceLevelAndLvyueStatusReport(this.q).then(rd => {
        if (rd && Array.isArray(rd)) {
          this.q.total = rd.length;
          this.tableData = rd;
        } else {
          this.tableData = [];
          this.q.total = 0;
        }
      }).catch(err => {
        this.$message.error('查询失败：' + (err.message || '未知错误'));
        this.tableData = [];
        this.q.total = 0;
      });
    },
    exportExcel() {
      updownfile.down("/api/swyl/v1/fl/flQudaoSalesVolume/downloadPriceLevelAndLvyueStatusReport", this.q, "post");
    },
  }
}
</script>
<style lang="scss">
.el-table thead.is-group th {
  background-color: #57aefe;
}
.w-content .el-table__footer-wrapper .cell {
  text-align: right;
}
.el-table--scrollable-x .el-table__body-wrapper {
  z-index: 1;
}
.el-table__fixed, .el-table__fixed-right {
  box-shadow: none;
}
.el-table__fixed, .el-table__fixed-right {
  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    content: '';
    z-index: 100;
    box-shadow: 0 0 10px rgba(0, 0, 0, .12);
  }
}
</style>
